import http from '@/utils/http';

export const searchHero = (parameter) => {
  return http.request({
    url: '/v1/games/hero/search',
    method: 'post',
    data: parameter
  })
}

export const getHeros = (parameter) => {
  return http.request({
    url: '/v1/games/hero/list',
    method: 'post',
    params: parameter
  })
}

export const editHero = (parameter) => {
  return http.request({
    url: '/v1/games/hero/edit',
    method: 'post',
    data: parameter
  })
}
